import styled from 'styled-components';

import { colors } from 'global/colors';

export const DescriptionAndContentContainer = styled.div`
  display: flex;
  margin-top: 100px;
  @media (max-width: 850px) {
    display: block;
  }
`;

export const DescriptionContainer = styled.div`
  flex: 0 0 40%;
  padding: 10px 50px 10px 10px;
  @media (max-width: 850px) {
    flex: 0 0 100%;
  }
`;

export const ContentContainer = styled.div`
  flex: 0 0 60%;
  padding: 10px;
  @media (max-width: 850px) {
    flex: 0 0 100%;
    padding: 0;
  }
`;

export const DescriptionHeading = styled.span`
  color: ${({ theme }) => theme.text};
  font-weight: 500;
  font-size: 1.5rem;
  margin-bottom: 10px;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.communityList.infoColor};
  white-space: pre-wrap;
  font-size: 15px;
  word-break: break-word;
  line-height: 26px;
`;

export const DropdownContainer = styled.div`
  display: flex;
  align-items: baseline;
  color: ${colors.darkGray};
  white-space: pre-wrap;
  margin-left: auto;
`;

export const LanguageLabel = styled.p`
  color: ${({ theme }) => theme.text};
  font-weight: 500;
  margin-bottom: 8px;
`;
